// extracted by mini-css-extract-plugin
module.exports = {"node":"LeafBranch_node__1756I"};